import { useStaticQuery, graphql } from 'gatsby';

export interface ISiteMetadata {
  langCode: string;
  pathPrefix: string;
  siteParentUrl: string;
  siteUrl: string;
}

export const useSiteMetadataQuery = () => {
  const data = useStaticQuery(graphql`
    query SiteMetadata {
      site {
        siteMetadata {
          langCode
          pathPrefix
          siteParentUrl
          siteUrl
        }
      }
    }
  `);

  return data?.site?.siteMetadata || {
    langCode: 'en-US',
    pathPrefix: '',
    siteParentUrl: '',
    siteUrl: '',
  };
};
